import {createContext, useContext} from 'react'
import PropTypes from 'prop-types'
import {useSimpleQuery} from '@frnt/base/hooks'
import {ResourceApiServiceProvider} from '../resource-api-service-provider'
import qs from 'qs'

const CryptoWalletAddressesServiceContext = createContext(undefined)

const CryptoWalletAddressesServiceProvider = ({
  children,
  baseApiHost,
  handleUnauthorized = () => {
    // Do nothing
  }
}) => {
  return (
    <ResourceApiServiceProvider
      Context={CryptoWalletAddressesServiceContext}
      handleUnauthorized={handleUnauthorized}
      host={baseApiHost}
      valueCallback={(axios) => ({
        create: async (payload) => {
          const {data} = await axios.post(`/api/v1/org/crypto_wallet_addresses`, payload)
          return data
        },
        list: async (query) => {
          const {data} = await axios.get(
            `/api/v1/org/crypto_wallet_addresses${qs.stringify(query, {
              addQueryPrefix: true
            })}`
          )
          return data
        }
      })}>
      {children}
    </ResourceApiServiceProvider>
  )
}

CryptoWalletAddressesServiceProvider.propTypes = {
  children: PropTypes.any,
  baseApiHost: PropTypes.string.isRequired,
  handleUnauthorized: PropTypes.func
}

const useCryptoWalletAddressesService = () => {
  const context = useContext(CryptoWalletAddressesServiceContext)
  if (context === undefined) {
    throw new Error('CryptoWalletAddressesServiceContext was not provided. Make sure your component is a child of the CryptoWalletAddressesServiceProvider.')
  }
  return context
}

const useCryptoWalletAddressesQuery = ({query, ...otherProps}) => {
  const cryptoWalletAddressesService = useCryptoWalletAddressesService()
  return useSimpleQuery({
    queryKey: `crypto_wallet_addresses-list-${JSON.stringify(query)}`,
    queryFn: async () => cryptoWalletAddressesService.list(query),
    ...otherProps
  })
}

export {CryptoWalletAddressesServiceProvider, useCryptoWalletAddressesService, useCryptoWalletAddressesQuery}
